export default __webpack_public_path__ + "static/media/elpro.e00081f5.svg";